import { createBrowserHistory } from 'history';
import routerLogger from 'helpers/routerLogger';

const history = createBrowserHistory();

routerLogger(history);

export default history;
